import { PAGE_SIZE_30 } from 'constants/data';
import { getData } from './Clients';
import { getFuzzySearchClient } from './ProductClientV2';

async function searchKeywords(keyword) {
  // const url = '/marketplace/product/v2/search/fuzzy';
  const body = {
    text: keyword,
    offset: 0,
    limit: PAGE_SIZE_30,
    // allSku: true,
  };
  // const res = await POST({ url, body });
  const res = await getFuzzySearchClient({ body });
  return getData(res);
}

async function searchByKeywords(keyword, hasIngredients = true) {
  // const url = '/marketplace/product/v2/search/fuzzy';
  const searchStrategy = {
    text: true,
    keyword: true,
    ingredient: hasIngredients,
  };
  const body = {
    text: keyword,
    offset: 0,
    limit: PAGE_SIZE_30,
    searchStrategy,
  };
  // const res = await POST({ url, body });
  return getFuzzySearchClient({ body });
}

export default {
  searchKeywords,
  searchByKeywords,
};
